import React from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import PropTypes from "prop-types"
import styled from "styled-components"
import ClipLoader from "react-spinners/dist/spinners/ClipLoader"

const spinnerSize = 100

const Wrapper = styled.div`
  background-color: #ffffff;
`

const LoadingSpinnerContainer = styled.div`
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: ${spinnerSize}px;
  height: ${spinnerSize}px;
`

// The component to display when loading, and checking for authentication status
function SplashScreen({ theme }) {
  const defaultSpinnerColor = "#513b8b"
  const spinnerColor = theme.primaryColor || defaultSpinnerColor

  return (
    <Wrapper>
      <LoadingSpinnerContainer>
        <ClipLoader loading color={spinnerColor} size={spinnerSize} />
      </LoadingSpinnerContainer>
    </Wrapper>
  )
}

SplashScreen.propTypes = {
  theme: PropTypes.shape({
    primaryColor: PropTypes.string.isRequired,
    primaryColorHover: PropTypes.string.isRequired,
    navBackgroundColor: PropTypes.string.isRequired,
  }).isRequired,
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(connect(mapStateToProps))(SplashScreen)



// WEBPACK FOOTER //
// ./src/routes/SplashScreen.jsx